import { RouterProvider } from 'react-router-dom';

import { Toaster } from '@/shared/ui';

import { QueryProvider } from './providers/QueryProvider';
import { router } from './routes';

/**
 * 앱 루트.
 *
 * - 전역 프로바이더 트리: TanStack Query → Router → Toaster
 * - Toaster는 라우터 바깥에 두어 라우트 전환 후에도 토스트가 살아있다.
 */
export function App(): React.JSX.Element {
  return (
    <QueryProvider>
      <RouterProvider router={router} />
      <Toaster />
    </QueryProvider>
  );
}
